import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UploadImage } from '../reduxToolkit/ShareSlice/shareApi';
import CustomModal from './Modal/CustomModal';
import {FILE_TYPE} from '../Helpers/fileType';
import {getPhotoPicker, PHOTO_PICKER_MODEL} from './PhotoPicker/SubComponent/Models/Models';
import {ACTION_MODEL} from '../Helpers/ActionModel';
import CustomPhotoPicker from './PhotoPicker/CustomPhotoPicker';
import {errorMsg} from '../Apis/functions';

const UploadFileModal = (props) => {
    const { titlen, ApiType, data, createDocValue, show, onUpdate, optionUpload, onHide } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [photoPickerFile, setPhotoPickerFile] = useState({...PHOTO_PICKER_MODEL})
    const [emptyFields, setEmptyFields] = useState(false);

    useEffect(() => {
        if (show) {
            setPhotoPickerFile({...PHOTO_PICKER_MODEL});
        }
    }, [show]);

    // funtion to call api or handle image
    const handleUploadImageAction = () => {
        let fileData = getPhotoPicker(photoPickerFile);
        if (fileData) {
            let documentId = !isNaN(data?.id) ? null : data?.id;

            switch (ApiType) {
                case ApiType:
                    const payload = {
                        id: data?.userId || data?.vehicleId,
                        document: '',
                        companyDocumentId: data?.companyDocumentId,
                    };
                    if (documentId) {
                        let formData = new FormData();
                        formData.append('id', documentId);
                        formData.append('option', optionUpload);
                        formData.append('file', fileData);
                        dispatch(UploadImage(formData)).then(( {payload: {data: { code, success }}}) => {
                                if (success === true) {
                                    toast.success(t('file_uploaded_successfully'));
                                    onUpdate();
                                    onHide();
                                } else {
                                    errorMsg(code)
                                }
                            },
                        );
                        // }
                    } else {
                        dispatch(createDocValue({ data: payload, file: fileData })).then(({payload: { data: { code, success }}}) => {
                                if (success === true) {
                                    toast.success(t('file_uploaded_successfully'));
                                    onUpdate();
                                    onHide();
                                } else {
                                    errorMsg(code)
                                }
                            },
                        );
                    }
                    break;
                default:
                    toast.error(t("something_went_wrong_2"));
            }
        } else {
            setEmptyFields(true)
            toast?.warn(t('please_select_a_file'));
        }
    };

    return (
        <CustomModal
            title={titlen}
            size='lg'
            buttonConfirm='confirm'
            {...props}
            onHide={()=>{
                setPhotoPickerFile({...PHOTO_PICKER_MODEL});
                onHide();
            }}
            onConfirm={() => {
                handleUploadImageAction();
            }}
        >
            <CustomPhotoPicker
                id='fp_ufm_create_fils'
                photoPicker={photoPickerFile}
                setPhotoPicker={setPhotoPickerFile}
                actionModel={ACTION_MODEL.CREATE}
                accept={{ ...FILE_TYPE.IMAGE_FILES }}
                required={true}
                classWith={'w-100'}
                showPreview={false}
                emptyFields={emptyFields}
            />
        </CustomModal>
    );
};

export default UploadFileModal;
